export const UTILS = {
  PAGINATION_SIBLING_COUNT_MOBILE: 0,
  PAGINATION_SIBLING_COUNT_DESKTOP: 1,
};
